var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_vm._v("嘉懿云仓 | Copyright © 闽ICP备19017889号-1")])
}
var staticRenderFns = []

export { render, staticRenderFns }